import { MutableRefObject, useEffect, useRef, useState } from 'react';
interface IntersectionOptions {
  root?: Element | null;
  rootMargin?: string;
  threshold?: number | number[];
}

export const useInView = (
  target: MutableRefObject<Element | null>,
  options: IntersectionOptions = {}
): [boolean, () => void] => {
  const [isIntersecting, setIsIntersecting] = useState(false);
  const observer = useRef<IntersectionObserver | null>(null);

  useEffect(() => {
    const callback: IntersectionObserverCallback = (entries) => {
      setIsIntersecting(entries[0]?.isIntersecting || false);
    };

    observer.current?.disconnect();

    if (target.current) {
      const _observer = new IntersectionObserver(callback, options);
      _observer.observe(target.current);
      observer.current = _observer;
    }

    return () => {
      observer.current?.disconnect();
    };
  }, [target, options]);

  const cancelObserver = () => {
    observer.current?.disconnect();
  };

  return [isIntersecting, cancelObserver];
};
